/**
 * Returns the next available groupId for a new group, based on the existing groups.
 * Uses Math.max to avoid collisions after deletions (length + 1 would collide).
 */
export function nextGroupId(groups: readonly { groupId: number }[]): number {
  if (groups.length === 0) return 1;
  return Math.max(...groups.map((g) => g.groupId)) + 1;
}
